import bus from '@/utils/bus'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import orderBy from 'lodash/orderBy'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { getAvailableCoupon, getCalculatePrice } from '@/api/activity/coupon'

export default {
  props: {
    // 优惠券优惠金额
    amount: {
      type: Number,
      default: 0,
    },
    // 其他优惠----数值=配置定价-配置原价
    discountAmount: {
      type: Number,
      default: 0,
    },
    // 优惠后价格
    couponAfterMoney: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      selectedCoupons: [],
      loading: false, // 获取价格计算loading
      couponsLoading: false, //获取优惠券信息loading
      choiceCouponMoney: 0,
      showPaymentDetail: false,
      showCouponListPopup: false,
      currentSkuId: '', // 当前选择的商品ID

      // 对于ru-genshin，newSubmitBtn+oldIdSelection，用该变量暂时记录这类交叉的cp
      uidForNewSubmitOldId: '',
    }
  },

  computed: {
    ...mapState([
      'region',
      'gameName',
      'selectedPaymentInfo',
      'selectedSkuInfo',
      'isDesktop',
      'userInfo',
    ]),
    ...mapState('detail', [
      'selectSkuItem',
      'selectChannelItem',
      'coupons',
      'isSaveCoupon',
      'userId',
      'selectOuterSkuItem',
    ]),
    ...mapGetters('detail', ['gameCouponList']),
    ...mapGetters([
      'isLogin',
      'isRuPubgm',
      'isAllExternalGames',
      'isParallelRequestsGame',
      'isStateOfSurvival',
    ]),

    hackSelectedSkuInfo() {
      if (!isEmpty(this.selectOuterSkuItem)) {
        return this.selectOuterSkuItem
          ? JSON.parse(this.selectOuterSkuItem)
          : this.selectSkuItem
      }
      return this.selectSkuItem
    },
    hackSelectedPaymentInfo() {
      return this.selectChannelItem
    },
    allCoupons() {
      // 初始化数据，整理所有优惠券的格式
      // 增加字段：webEnable: true 当前套餐可用优惠券，false，当前游戏不可用优惠券
      const couponList = this.coupons?.couponList || []
      const otherCouponList = this.coupons?.otherCouponList || []
      return cloneDeep([
        ...couponList.map((item) => {
          item.webEnable = true
          return item
        }),
        ...otherCouponList.map((item) => {
          item.webEnable = false
          return item
        }),
      ])
    },
    expireInXXMinuteCoupons() {
      // 当前选中的在30分钟以内的所有优惠券
      return this.selectedCoupons.filter((item) => item.expireInXXMinute)
    },
    countdownData() {
      // 是否展示倒计时
      // 倒计时-当默认/用户自行勾选的优惠券或优惠券组合中，有优惠券将在30分钟及以内失效时 展示
      // 数值：展示 优惠券或优惠券组合中最先过期的倒计时时间
      if (this.expireInXXMinuteCoupons.length === 0) {
        return { show: false, time: '' }
      }
      // 将过期时间userCouponExpireTime转为数值类型
      const tmp = this.expireInXXMinuteCoupons.map((item) => {
        return { ...item, a: '' + item.userCouponExpireTime }
      })
      // 最低使用限制金额的券 - 根据使用门槛进行升序排序，获取第一个
      const coupons = orderBy(tmp, ['userCouponExpireTime'], ['asc'])
      return {
        show: true,
        time: coupons[0].userCouponExpireTime,
      }
    },

    isLoginSelected() {
      // 注:isSaveCoupon不要删除,虽然后面没有用到,但是是用于监听是否已经领到了优惠券的
      // 如果已经领了优惠券,isLoginSelected的数据会变化,同时会再调用一次查询优惠券的接口
      const {
        hackSelectedPaymentInfo,
        userInfo,
        isSaveCoupon,
        userId,
        uidForNewSubmitOldId,
      } = this
      return {
        hackSelectedPaymentInfo,
        userInfo,
        isSaveCoupon,
        userId,
        uidForNewSubmitOldId,
      }
    },
  },
  created() {
    if (!process.client) return
    bus.$on('inputUidForAvaliableCoupon', (val) => {
      this.uidForNewSubmitOldId = val
    })
  },
  mounted() {},
  beforeDestroy() {
    bus.$off('inputUidForAvaliableCoupon')
  },
  watch: {
    isLoginSelected: {
      handler(val) {
        const { hackSelectedPaymentInfo, userInfo } = val
        if (isEmpty(hackSelectedPaymentInfo) || isEmpty(userInfo)) {
          this.initData()
        } else {
          this.getCouponData(hackSelectedPaymentInfo)
        }
      },
      deep: true,
      immediate: true,
    },
    coupons(val) {
      this.$emit('handleCouponData', val)
    },
    choiceCouponMoney(val) {
      this.$emit('handleRealPayPrice', val * 1)
    },
    selectedCoupons(val) {
      if (val.length > 0) {
        this.calculatePrice()
      } else {
        this.choiceCouponMoney = 0
        this['detail/setCouponDiscountMoney'](0)
      }
      this.$emit('handleChoiceCouponId', val)
    },
    loading(val) {
      this.$emit('onCalculatePriceLoading', val)
      this['detail/setToggleCouponLoging'](val)
    },
  },
  methods: {
    ...mapMutations([
      'detail/setCoupons',
      'detail/setCouponData',
      'detail/setToggleCouponLoging',
      'detail/setCouponDiscountMoney',
      'detail/setCreateCouponrState',
      'detail/setShowDiscount',
    ]),
    loginSuccess(cb) {
      bus.$off('autoLogin')
      bus.$off('login success')
      bus.$on('autoLogin', cb)
      bus.$on('login success', cb)
    },
    onSelectedCoupons(data) {
      this['detail/setCouponData'](data)
      this.selectedCoupons = data
    },
    initData() {
      this['detail/setCoupons']({})
      this.choiceCouponMoney = 0
    },
    async getCouponData() {
      this.initData()
      this.couponsLoading = true
      const { skuId, channelPrice } = this.hackExternalCpPars()

      if (!channelPrice) return
      const params = {
        country: this.region,
        game: this.gameName,
        ware: skuId,
        price: channelPrice,
      }

      if (this.userId) {
        params.gameUid = this.userId
      }

      if (
        this.region === 'ru' &&
        this.gameName === 'genshin' &&
        this.uidForNewSubmitOldId
      ) {
        params.gameUid = this.uidForNewSubmitOldId
      }

      if (this.isParallelRequestsGame || this.isStateOfSurvival) {
        params.ware = this.hackSelectedSkuInfo?.skuId || ''
      }

      try {
        const result = await getAvailableCoupon(params)

        const { skuId: currentSkuId, channelPrice: currentChannelPrice } =
          this.hackExternalCpPars()

        const data = result || {}
        // 对比返回的商品ID和请求的商品ID是否一致，如果不一致则不赋值
        // 兼容弱网情况下，最后返回的优惠券覆盖先返回的优惠券的情况
        if (this.isAllExternalGames) {
          if (channelPrice !== currentChannelPrice) return
        } else {
          if (skuId !== currentSkuId) return
        }
        this.currentSkuId = currentSkuId
        this['detail/setCoupons'](data)

        // warn :兼容下单的时候自动跳转支持流程
        if (data.couponList.length) {
          this['detail/setCreateCouponrState']({
            isCoupon: 'success',
            isCompute: 'pending',
          })
        } else {
          this['detail/setCreateCouponrState']({
            isCoupon: 'success',
            isCompute: 'fail',
          })
        }

        // tips 注意：是否有初始进入不计算价格的运算
        // const _discountMoney = data.discountMoney || 0
        // this.choiceCouponMoney = _discountMoney
        // this['detail/setCouponDiscountMoney'](_discountMoney)
      } catch (error) {
        this['detail/setCreateCouponrState']({
          isCoupon: 'fail',
          isCompute: 'pending',
        })
        window.console.log('[getCouponData]报错', error)
      } finally {
        this.couponsLoading = false
      }
    },
    async calculatePrice() {
      this.loading = true
      // 计算优惠券的价格
      if (!this.isLogin) return

      const { skuId, channelPrice } = this.hackExternalCpPars()

      try {
        const couponIdList = this.selectedCoupons
          .map((item) => item.userCouponId)
          .join(',')

        const params = {
          game: this.gameName,
          country: this.region,
          price: channelPrice,
          couponIdList,
        }

        // 兼容弱网情况下，选择的优惠券和商品价格不匹配的情况
        // 保持获取到的优惠券和计算价格的优惠券一致，如果不一致则不调用接口
        if (skuId !== this.currentSkuId) return
        const response = await getCalculatePrice(params)
        const _discountMoney = response.discountMoney || 0

        this.choiceCouponMoney = _discountMoney
        this['detail/setCouponDiscountMoney'](_discountMoney)
        this['detail/setCreateCouponrState']({
          isCoupon: 'success',
          isCompute: 'success',
        })
      } catch (error) {
        window.console.log('[calculatePrice]报错', error)
        this['detail/setCreateCouponrState']({
          isCoupon: 'success',
          isCompute: 'fail',
        })
      } finally {
        this.loading = false
      }
    },
    // 兼容国外部的CP
    hackExternalCpPars() {
      let skuId = '',
        channelPrice = 0

      // 获取优惠券信息
      if (this.isAllExternalGames) {
        skuId = this.selectSkuItem?.skuId
        channelPrice = this.hackSelectedPaymentInfo?.channelPrice
      } else {
        skuId = this.hackSelectedPaymentInfo?.skuId
        channelPrice = this.hackSelectedPaymentInfo?.channelPrice
      }
      return {
        skuId,
        channelPrice,
      }
    },
  },
}
